var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
// Imports
import Vue from "vue";
import Component from "vue-class-component";
import { Clubs } from "../../../modules/clubs";
import { Utilities } from "../../../services/utilities";
// Define vue parameters
var ListClubsComponent = /** @class */ (function (_super) {
    __extends(ListClubsComponent, _super);
    /**
     * Setup the child and parent class
     */
    function ListClubsComponent() {
        var _this = _super.call(this) || this;
        // Create a clubs instance
        _this.clubs = new Clubs();
        return _this;
    }
    /**
     * Component setup on mount
     */
    ListClubsComponent.prototype.mounted = function () {
        var _this = this;
        var self = this;
        if (this.$props.playerId === 'me') {
            this.$data.showEdit = true;
        }
        // Get the players clubs
        this.clubs.getAll(this.$props.playerId).then(function (r) {
            //r.resultsCount;
            r.clubs = self.setDistanceBarWidths(r.clubs);
            // Assign response to Vue $data
            _this.$data.playerClubs = r.clubs;
            _this.$data.playerClubsLength = _this.$data.playerClubs.length;
            _this.$data.loading = false;
        });
    };
    /**
     * Determine bar width as a percentage based on width
     * relative to largest distance
     */
    ListClubsComponent.prototype.setDistanceBarWidths = function (clubs) {
        var maxDistance = Math.max.apply(Math, clubs.map(function (club) { return club.averageYards; }));
        var minimumWidth = 10;
        clubs.forEach(function (club) {
            // Minimum 10% bar width
            club.barWidth = Math.max(minimumWidth, (club.averageYards / maxDistance) * 100);
        });
        return clubs;
    };
    /**
     * Delete a club and update the view upon deletion
     */
    ListClubsComponent.prototype.deleteClub = function (clubId, dataIndex, clubName) {
        var _this = this;
        Utilities.confirm("Are you sure you want to delete your " + clubName + "?").then(function () {
            // User has confirmed, delete the club
            _this.clubs["delete"](clubId).then(function (r) {
                // Remove the club from the $data object
                _this.$delete(_this.$data.playerClubs, dataIndex);
            });
        });
    };
    ListClubsComponent.prototype.openClubDetail = function (clubId) {
        var redirectUrl = window.location.pathname + "/" + clubId;
        // @TODO - reload data without refreshing page
        window.location.href = redirectUrl + Utilities.getIframeParam();
    };
    ListClubsComponent.prototype.showModal = function (modal) {
        this.$modal.show(modal);
    };
    ListClubsComponent = __decorate([
        Component({
            props: ["playerId"],
            data: function () {
                return {
                    playerClubs: null,
                    playerClubsCount: null,
                    editClubId: null,
                    loading: true,
                    showEdit: false,
                };
            }
        })
        // Define the component code
    ], ListClubsComponent);
    return ListClubsComponent;
}(Vue));
export default ListClubsComponent;
